import gql from 'graphql-tag'

import {
	productMain,
	lists as listsFragment,
	ingredients as ingredientsFragment,
	ingredientsGeneral,
	intervals,
	options as optionsFragment,
	properties,
	concepts as conceptsFragment,
	restaurant as restaurantFragment
} from '../fragments/'

export const cashRegisters = gql`
mutation updateProduct_cashRegisters($id: ID! $fields: ProductFields) {
	cashAssist {
		updateProduct(id: $id, fields: $fields) {
			id
			mod_ver
			cashRegisterId
		}
	}
}
`

export const product = gql`
mutation updateProduct_product($id: ID! $fields: ProductFields) {
	cashAssist {
		updateProduct(id: $id, fields: $fields) {
			id
			mod_ver
			...productmain
			category {
				id
				name
			}
		}
	}
}
${productMain}`

export const setsInfo = gql`
mutation updateProduct_sets($id: ID! $fields: ProductFields) {
	cashAssist {
		updateProduct(id: $id, fields: $fields) {
			id
			mod_ver
			setsMode
			priceDiffMode
			printChosenSubProductsFlag
			fixProductsAutoSelect
			isPricesNormalByDefaultInSet
			isFastSelection
			isForTasting
			isMenuName
			printChosenSubProducts
		}
	}
}
`

export const sets = gql`
mutation setProductSets($id: ID! $fields: [SetInput]!) {
	cashAssist {
		setProductSets(id: $id, fields: $fields) {
			id
			mod_ver
			sets {
				category {
					id
					name
				}
				minQuantity
				maxQuantity
				priceLevel
				isCollectPoints
				weekDays
				fixProducts {
					code
					amount
					price
				}
			}
		}
	}
}
`

export const hardware = gql`
mutation updateProduct_hardware($id: ID! $fields: ProductFields!) {
	cashAssist {
		updateProduct(id: $id, fields: $fields) {
			id
			mod_ver
			isWeighted
			isTareInLabelMode
			tare
			EANCode
			EANstatistics
		}
	}
}
`

export const restaurant = gql`
mutation updateProduct_restaurant($id: ID! $fields: ProductFields!) {
	cashAssist {
		updateProduct(id: $id, fields: $fields) {
			id
			mod_ver
			...restaurant
		}
	}
}
${restaurantFragment}
`

export const ingredients = gql`
mutation updateProduct_ingredients($id: ID! $fields: ProductFields) {
	cashAssist {
		updateProduct(id: $id, fields: $fields) {
			id
			mod_ver
			...ingredientsGeneral
			...ingredients
			linkProduct {
				id
				name
				...ingredients
			}
		}
	}
}
${ingredientsFragment}
${ingredientsGeneral}
`

export const options = gql`
mutation updateProduct_options($id: ID! $fields: ProductFields!) {
	cashAssist {
		updateProduct(id: $id, fields: $fields) {
			id
			mod_ver
			...options
		}
	}
}
${optionsFragment}
`

export const lists = gql`
mutation updateProduct_lists($id: ID! $fields: ProductFields!) {
	cashAssist {
		updateProduct(id: $id, fields: $fields) {
			id
			mod_ver
			...lists
		}
	}
}
${listsFragment}
`

export const loyaltyCard = gql`
mutation updateProduct_loyaltyCard($id: ID! $fields: ProductFields!) {
	cashAssist {
		updateProduct(id: $id, fields: $fields) {
			id
			mod_ver
			discount
			cardSurchargePercent
			cardSurchargeFrom
			cardChargeAmount
			points {
				type
				quantity
				points
			}
			pointsCost
			pointsPriceLevel
		}
	}
}
`

export const availability = gql`
mutation updateProduct_availability($id: ID! $fields: ProductFields!) {
	cashAssist {
		updateProduct(id: $id, fields: $fields) {
			id
			mod_ver
			...intervals
			...properties
			nameInOrder
			inventoryUnit
			orderUnit
			numberPerUnit
			minOrder
			isInventory
			isForTasting
			canCopy
			visibleStatus
			bakeryReturn
			bakeryReturnEndOfDay
			bakeryStock
		}
	}
}
${intervals}
${properties}
`

export const concepts = gql`
mutation updateProduct_concepts($id: ID! $fields: ProductFields!) {
	cashAssist {
		updateProduct(id: $id, fields: $fields) {
			id
			mod_ver
			name
			...concepts
		}
	}
}
${conceptsFragment}
`

export default {
	product,
	cashRegisters,
	setsInfo,
	sets,
	hardware,
	restaurant,
	ingredients,
	options,
	lists,
	loyaltyCard,
	availability,
	concepts
}
